import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { IHealth } from 'src/types/health.type';
import { setHealth } from './health.slice';

export default function useHealth() {
  const dispatch = useDispatch();
  const health = useAppSelector((state) => state.health);

  const changeHealth = (health: IHealth | null) => {
    dispatch(setHealth(health));
  };

  return {
    health,
    changeHealth,
  };
}
